/* eslint-disable @typescript-eslint/no-unused-vars */
import StorageRepository from '../../Domain/Repositories/StorageRepository';
class SSRNoOpRepository extends StorageRepository {
  constructor() {
    super();
  }
  set(key, value, expires) {
    return;
  }
  get(key) {
    return undefined;
  }
  isExpired(key) {
    return true;
  }
  remove(key) {
    return;
  }
}

export { SSRNoOpRepository as default };